import type { AddressType } from 'tonweb';
import { Cell } from 'tonweb/dist/types/boc/cell';

export type TonSigningTransactionType = {
  fromAddress: string;
  publicKey: string;
  value: bigint;
  toAddress: string;
  memo: string | Uint8Array | Cell;
  tokenContractAddress?: string;
  tokenPrecision?: number;
};

export const mockTonChainId = 1100;
export const mockTonTestnetChainId = 1101;
export const tonDecimals = 9;

const apiKey =
  '1b312c91c3b691255130350a49ac5a0742454725f910756aff94dfe44858388e';
export const tonRpc = 'https://toncenter.com/api/v2/jsonRPC';
export const hashHttp = 'https://toncenter.com/api/index/v1';

export async function getTonWeb() {
  return (await import('tonweb')).default
}

async function getTonWebProvider() {
  const TonWeb = await getTonWeb();
  return new TonWeb(new TonWeb.HttpProvider(tonRpc, { apiKey: apiKey }));
}

const apiKeyTest =
  '227f87a614319d10e4c20f0f485cd101eca12989bf59da0e33b3c3da8ad534b2';
const tonRpcTest = 'https://testnet.toncenter.com/api/v2/jsonRPC';
const hashHttpTest = 'https://testnet.toncenter.com/api/index/v1';

async function getTonTestWebProvider() {
  const TonWeb = await getTonWeb();
  return new TonWeb(
    new TonWeb.HttpProvider(tonRpcTest, { apiKey: apiKeyTest })
  );
}

export const getTonBalance = async ({
  tonAddress,
  tokenContractAddress,
  tokenPrecision,
  chainId,
}: {
  tonAddress: string;
  tokenContractAddress?: AddressType;
  tokenPrecision?: number;
  chainId?: number;
}) => {
  const TonWeb = await getTonWeb();

  // get the decentralized RPC endpoint
  const tonWeb =
    chainId === mockTonTestnetChainId
      ? await getTonTestWebProvider()
      : await getTonWebProvider();
  const wallet = tonWeb.wallet.create({ address: tonAddress }); // if your know only address at this moment
  // const wallet = tonWeb.wallet.create({publicKey: TonWeb.utils.hexToBytes(publicKey)});

  const address = await wallet.getAddress();
  if (tokenContractAddress) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const jettonMinter = new TonWeb.token.jetton.JettonMinter(tonWeb.provider, {
      address: tokenContractAddress,
    });
    const jettonWalletAddress = await jettonMinter.getJettonWalletAddress(
      address
    );
    // console.log('My jetton wallet for ' + name + ' is ' + jettonWalletAddress.toString(true, true, true));
    const jettonWallet = new TonWeb.token.jetton.JettonWallet(tonWeb.provider, {
      address: jettonWalletAddress,
    });
    const balance = (await jettonWallet.getData()).balance;
    return {
      balance,
      formatted: Number(balance.toString()) / 10 ** tokenPrecision,
    };
  }

  const balance = await tonWeb.getBalance(address);
  return { balance, formatted: TonWeb.utils.fromNano(balance) };
};

// {'@type': 'ok', '@extra': '1724056253.9801953:10:0.38478557394306645', 'msgHash': ''};
export async function sendTransaction(
  signedTransaction: string,
  walletAddress?: string,
  chainId?: number
) {
  const tonWeb =
    chainId == mockTonTestnetChainId
      ? await getTonTestWebProvider()
      : await getTonWebProvider();

  const cell = tonWeb.boc.Cell.fromBoc(
    tonWeb.utils.base64ToBytes(signedTransaction)
  )[0];
  const msgHash = tonWeb.utils.bytesToBase64(await cell.hash());

  const lt = '';

  const result = await tonWeb.provider.sendBoc(signedTransaction);
  return { ...result, msgHash, lt };
}

export const tonRpcApiKey = apiKey;
